"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionsTypeEnum = void 0;
var QuestionsTypeEnum;
(function (QuestionsTypeEnum) {
    QuestionsTypeEnum["OTHER"] = "other";
    QuestionsTypeEnum["T_SHIRT_SIZE"] = "tshirtSize";
    QuestionsTypeEnum["PHONE_NUMBER"] = "phoneNumber";
    QuestionsTypeEnum["EMAIL_ADDRESS"] = "emailAddress";
    QuestionsTypeEnum["ADDRESS"] = "address";
    QuestionsTypeEnum["BIRTH_DATE"] = "birthDate";
    QuestionsTypeEnum["PREFERRED_TEAM"] = "preferredTeam";
    QuestionsTypeEnum["WAIVER"] = "waiver";
    QuestionsTypeEnum["CUSTOM_WAIVER"] = "customWaiver";
})(QuestionsTypeEnum = exports.QuestionsTypeEnum || (exports.QuestionsTypeEnum = {}));
//# sourceMappingURL=questions.enum.js.map